module.exports = __webpack_public_path__ + "media/images/pokerroom/redkings/step4-pict02-9d9bf2754ed80a0216be5f7783ec9a19.jpg";